module.exports = __webpack_public_path__ + "media/images/welcome_intensive_training-f53c123d2148638124da285ec2f7d336.svg";